/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerInteractionSettingRequest } from '../../models/customer-interaction-setting-request';
import { CustomerInteractionSettingResponse } from '../../models/customer-interaction-setting-response';
import { GroupOrderingSettingsRequest } from '../../models/group-ordering-settings-request';
import { GroupOrderingSettingsResponse } from '../../models/group-ordering-settings-response';
import { OrderProcessingStatusSettingRequest } from '../../models/order-processing-status-setting-request';
import { OrderProcessingStatusSettingResponse } from '../../models/order-processing-status-setting-response';
import { SettingRequest } from '../../models/setting-request';
import { SettingResponse } from '../../models/setting-response';
import { TenantNutritionalDefaultsSettingRequest } from '../../models/tenant-nutritional-defaults-setting-request';
import { TenantNutritionalDefaultsSettingResponse } from '../../models/tenant-nutritional-defaults-setting-response';

export interface UpsertSetting$Params {
  tenantId: string;
  id: 'CHECKIN_URL' | 'ORDER_STATUS_TRACKING_URL' | 'ORDER_PROCESSING_STATUS' | 'CUSTOMER_INTERACTION' | 'GROUP_ORDERING' | 'BRAND_NUTRITIONAL_DEFAULTS';
  'Active-Tenant-Identifier': string;
      body: (SettingRequest | OrderProcessingStatusSettingRequest | CustomerInteractionSettingRequest | GroupOrderingSettingsRequest | TenantNutritionalDefaultsSettingRequest)
}

export function upsertSetting(http: HttpClient, rootUrl: string, params: UpsertSetting$Params, context?: HttpContext): Observable<StrictHttpResponse<(SettingResponse | OrderProcessingStatusSettingResponse | CustomerInteractionSettingResponse | GroupOrderingSettingsResponse | TenantNutritionalDefaultsSettingResponse)>> {
  const rb = new RequestBuilder(rootUrl, upsertSetting.PATH, 'put');
  if (params) {
    rb.path('tenantId', params.tenantId, {});
    rb.path('id', params.id, {});
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<(SettingResponse | OrderProcessingStatusSettingResponse | CustomerInteractionSettingResponse | GroupOrderingSettingsResponse | TenantNutritionalDefaultsSettingResponse)>;
    })
  );
}

upsertSetting.PATH = '/tenants/{tenantId}/settings/{id}';
